import { useEffect, useRef, useState } from 'react';
import './styles/admin.scss';
import { ApiHelper } from '../../apiHelper/ApiHelper';
import { resolveInstagramImage } from '../../Constants';

const SLOTS = 4;

type Slot = { url: string; imageUrl: string };
const empty = (): Slot[] => Array.from({ length: SLOTS }, () => ({ url: "", imageUrl: "" }));

export default function AdminSettings() {
    const [slots, setSlots] = useState<Slot[]>(empty());
    const [loaded, setLoaded] = useState(false);
    const [uploading, setUploading] = useState<number | null>(null);
    const fileInputs = useRef<(HTMLInputElement | null)[]>([]);
    const api = new ApiHelper();

    useEffect(() => { load(); }, []);

    async function load() {
        try {
            const posts: { position: number; url: string; imageUrl?: string }[] = await (await api.adminSettingsApi.instagramPosts()).json();
            const next = empty();
            posts.forEach(p => { if (p.position >= 0 && p.position < SLOTS) next[p.position] = { url: p.url, imageUrl: p.imageUrl ?? "" }; });
            setSlots(next);
        } catch (x: any) { api.adminError(x); } finally { setLoaded(true); }
    }

    function patch(i: number, p: Partial<Slot>) { setSlots(slots.map((s, idx) => idx === i ? { ...s, ...p } : s)); }

    async function uploadImage(i: number, file: File) {
        setUploading(i);
        try {
            const res = await (await api.adminContentApi.upload(file)).json();
            patch(i, { imageUrl: res.url });
            api.alert.success("Obrázek nahrán");
        } catch (x: any) { api.adminError(x); } finally { setUploading(null); }
    }

    async function save() {
        try {
            const posts = slots.filter(s => s.url.trim()).map(s => ({ url: s.url.trim(), imageUrl: s.imageUrl.trim() || null }));
            await api.adminSettingsApi.setInstagramPosts({ posts });
            api.alert.success("Instagram příspěvky uloženy");
            await load();
        } catch (x: any) { api.adminError(x); }
    }

    return (
        <div>
            <div className="adminHead"><div><h1>Nastavení</h1><p>Obsah webu spravovaný napřímo</p></div></div>

            <div className="aCard">
                <h2>Sleduj nás na Instagramu</h2>
                <p className="muted">U každého příspěvku vlož odkaz a nahraj čtvercový obrázek, který se zobrazí na úvodní stránce. Bez vlastního obrázku se použije automatický (oříznutý) náhled z Instagramu.</p>
                <div className="igEditor">
                    {slots.map((s, i) => (
                        <div key={i} className="igSlot">
                            <div className="igPreview">
                                {s.imageUrl
                                    ? <img src={resolveInstagramImage(s.imageUrl)} alt="" referrerPolicy="no-referrer" />
                                    : <span className="muted">Auto náhled<br />z odkazu</span>}
                            </div>
                            <div className="igFields">
                                <div className="aField"><label>Příspěvek {i + 1} — odkaz</label>
                                    <input value={s.url} onChange={e => patch(i, { url: e.target.value })} placeholder="https://www.instagram.com/p/…" />
                                </div>
                                <div className="igImgRow">
                                    <input ref={el => fileInputs.current[i] = el} type="file" accept="image/*" hidden
                                        onChange={e => { const f = e.target.files?.[0]; if (f) uploadImage(i, f); e.target.value = ""; }} />
                                    <button className="aBtn ghost" type="button" disabled={uploading === i} onClick={() => fileInputs.current[i]?.click()}>
                                        {uploading === i ? "Nahrávám…" : (s.imageUrl ? "Změnit obrázek" : "Nahrát obrázek")}
                                    </button>
                                    {s.imageUrl && <button className="aBtn ghost" type="button" onClick={() => patch(i, { imageUrl: "" })}>Odebrat</button>}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="aActions"><button className="aBtn" onClick={save} disabled={!loaded}>Uložit</button></div>
            </div>
        </div>
    );
}
